import { render, staticRenderFns } from "./ContainersMap.vue?vue&type=template&id=0ed36bbe"
import script from "./ContainersMap.vue?vue&type=script&lang=js"
export * from "./ContainersMap.vue?vue&type=script&lang=js"
import style0 from "./ContainersMap.vue?vue&type=style&index=0&id=0ed36bbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports